import * as React from 'react';
import * as Services from '../../../../Services/Services';
import { useBoolean } from '@fluentui/react-hooks';
import { IEventSchedulesApi } from '../../../../Services/API/EventSchedules/IEventSchedulesApi';
import { ComboBox, DetailsHeader, DetailsListLayoutMode, IColumn, IDetailsColumnStyles, IDetailsHeaderProps, IDetailsHeaderStyles, IRenderFunction, MessageBarType, SelectionMode, ShimmeredDetailsList, SpinButton, Stack, useTheme } from '@fluentui/react';
import { IStatusMessage } from '../../../../Models/IStatusMessage';
import { ITeacherLessonsByMonth } from '../../../../Models/Reports/ITeacherLessonsByMonth';
import { PageTitle } from '../../../PageTitle';

interface IReportTeacherLessonsByMonthProps {

}


export const ReportTeacherLessonsByMonth: React.FunctionComponent<IReportTeacherLessonsByMonthProps> = (props) => {
    const theme = useTheme();
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [month, setMonth] = React.useState(0);
    const [year, setYear] = React.useState(0);
    const [report, setReport] = React.useState<ITeacherLessonsByMonth[]>([]);

    React.useEffect(() => {
        const date = new Date(Date.now());
        let month = date.getMonth();
        let year = date.getFullYear();

        if (month === 1) {
            month = 12;
            year--;
        }
        else {
            month;
        }
        setMonth(month);
        setYear(year);
    }, []);

    React.useEffect(() => {
        if (year !== 0) {
            loadData();
        }
    }, [month, year])


    const loadData = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const schedulerApi = Services.ServicesProvider.GetService<IEventSchedulesApi>(Services.EventSchedulesApi);
        const report = await schedulerApi.reportTacherLessonsByMonth(month, year);
        if (report.isSuccess && report.data) {
            setStatusMessage(undefined);
            setReport(report.data);
        }
        else {
            setStatusMessage({ message: report.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }


    const headerStyle: Partial<IDetailsColumnStyles> = {
        cellName: {
            fontFamily: "Comfortaa, serif",
            color: theme.palette.blue,

        },
        cellTitle: {

        }
    }

    const _columns: IColumn[] = [
        { key: 'userName', name: 'Lektor', fieldName: 'userName', minWidth: 80, maxWidth: 200, isResizable: true, styles: headerStyle },
        { key: 'payment', name: 'Kč/lekce', fieldName: 'payment', minWidth: 80, maxWidth: 90, isResizable: true, isCollapsible: true, styles: headerStyle },
        { key: 'lessons', name: 'Odučeno', fieldName: 'lessons', minWidth: 80, maxWidth: 90, isResizable: true, styles: headerStyle },
        { key: 'total', name: 'Celkem Kč', fieldName: 'total', minWidth: 80, maxWidth: 90, isResizable: true, styles: headerStyle },
       ]

    const renderItemColumn = (item: ITeacherLessonsByMonth, index?: number, column?: IColumn) => {
        if (index != undefined && column != undefined) {
            const fieldContent = item[column.fieldName as keyof ITeacherLessonsByMonth];

            switch (column.key) {
                case "userName":
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{item.lastName + " " + item.firstName}</span>
                default:
                    return <span style={{ height: '100%', display: 'flex', alignItems: 'center' }}>{fieldContent?.toString()}</span>
            }
        }
    }

    const headerRowStyle: Partial<IDetailsHeaderStyles> = {
        root: {
            borderColor: theme.palette.blue,
            borderBottomWidth: 2
        }
    }

    const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (props) {
            props = { ...props, styles: headerRowStyle };
            return (
                <DetailsHeader
                    {...props}
                />
            );
        }
        return null;
    }




    return (<Stack styles={{ root: { paddingLeft: 20, paddingRight: 20 } }}>
        <PageTitle title="Report - odměny pro lektory " />
        <Stack horizontal padding={10} tokens={{ childrenGap: 10, maxWidth:400 }} horizontalAlign="center">
            <SpinButton label="Měsíc" style={{ width:100 }} value={month.toString()} onChange={(e, v) => setMonth(v ? Number.parseInt(v) : 0)} />
            <SpinButton label="Rok" style={{ width: 100 }}  value={year.toString()} onChange={(e, v) => setYear(v ? Number.parseInt(v) : 0)} />
        </Stack>
        <ShimmeredDetailsList
            items={report}
            columns={_columns}
            setKey="set"
            onRenderDetailsHeader={onRenderDetailsHeader}
            selectionMode={SelectionMode.none}
            layoutMode={DetailsListLayoutMode.justified}
            onRenderItemColumn={renderItemColumn}

            selectionPreservedOnEmptyClick={false}
            ariaLabelForSelectionColumn="Výběr věkové skupiny"
            ariaLabelForSelectAllCheckbox="Výběr věkové skupiny"
            checkButtonAriaLabel="Vyber řádek"
        />
    </Stack>)
}
